export default __webpack_public_path__ + "static/media/FutureGlider-BrianBolger.b10973ab.mp3";